import React, { useState, useEffect } from "react";
import axios from "axios";
import Table from "react-bootstrap/Table";
import Button from "react-bootstrap/Button";
import Spinner from "react-bootstrap/Spinner";
import "bootstrap-icons/font/bootstrap-icons.css";
import Swal from "sweetalert2";
import { Form, Modal, Nav } from "react-bootstrap";
import { Row, Col, Container, Card } from "react-bootstrap";
import Pagination from 'react-bootstrap/Pagination';
import { doesNotMatch } from "assert";
const Withdraw = () => {
  const [loading, setLoading] = useState(false);
  const [withdrawals, setWithdrawals] = useState([]);
  const [TransactionId, setTransactionId] = useState([]);
  const guestId = localStorage.getItem("userid");
  const [showModal, setShowModal] = useState(false);
  const [amount, setAmount] = useState(0);
  const [selectedTransactionId, setSelectedTransactionId] = useState(null);
  const [selectedAmount, setSelectedAmount] = useState(null);
  const [totalDeposit, setTotalDeposit] = useState(0);
  const [totalSuccessAmount, setTotalSuccessAmount] = useState(0);
  const [totalPendingAmount, setTotalPendingAmount] = useState(0);
  const [totalRejectedAmount, setTotalRejectedAmount] = useState(0);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [activeTab, setActiveTab] = useState("total");
  const [searchQuery, setSearchQuery] = useState("");
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [rejectionReason, setRejectionReason] = useState("");
  const [showRejectionModal, setShowRejectionModal] = useState(false);
  const [transactionToReject, setTransactionToReject] = useState(null);
  const [customReason, setCustomReason] = useState("");

  const openModal = (imageUrl) => {
    setSelectedImage(imageUrl);
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setModalIsOpen(false);
    setSelectedImage(null);
  };

  const handleOpenModal = (transaction) => {
    setSelectedTransactionId(transaction._id);
    setSelectedAmount(transaction.amount);
    setShowModal(true);
  };

  useEffect(() => {
    loadWithdrawals();
  }, []);

  const rejectionOptions = [
    "-- Select Remark --",
    "ROLLOVER",
    "NOT COMPLETE",
    "YOU HAVE MADE PAYMENT IN OUR OLD ACCOUNT",
    "PLEASE CONTACT CUSTOMER SUPPORT",
    "PAYMENT NOT RECEIVED IN BANK",
    "REPEAT PAYMENT SLIP",
    "UPLOAD PROPER SCREENSHOT WITH UTR",
    "Custom"
  ];
  const loadWithdrawals = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        // "https://api.Cash365days.in/user/transaction-history"
       `${process.env.REACT_APP_API_URL}/user/transaction-history`
      );

      const transactions = response.data.transactions || [];
      const filteredDeposits = transactions.filter(
        (transaction) => transaction.type === "Deposit"
      );
      setWithdrawals(filteredDeposits);
      setTotalDeposit(response.data.totalDeposit);

      const ids = filteredDeposits.map((transaction) => transaction._id);
      setTransactionId(ids);

      const successAmount = filteredDeposits
        .filter((transaction) => transaction.status === "Success")
        .reduce((acc, transaction) => acc + transaction.amount, 0);

      const pendingAmount = filteredDeposits
        .filter((transaction) => transaction.status === "Pending")
        .reduce((acc, transaction) => acc + transaction.amount, 0);

      const rejectedAmount = filteredDeposits
        .filter((transaction) => transaction.status === "Rejected")
        .reduce((acc, transaction) => acc + transaction.amount, 0);

      setTotalSuccessAmount(successAmount);
      setTotalPendingAmount(pendingAmount);
      setTotalRejectedAmount(rejectedAmount);

      // Calculate total pages
      setTotalPages(Math.ceil(filteredDeposits.length / itemsPerPage));
    } catch (error) {
      console.error("❌ Error fetching deposit transactions:", error);
    } finally {
      setLoading(false);
    }
  };

  // const handleApprove = async (transactionId, status) => {
  //   setLoading(true);
  //   try {
  //     const response = await axios.post(
  //       "https://api.Cash365days.in/admin/approveTransaction",
  //       {
  //         transactionId,
  //         status,
  //       }
  //     );

  //     if (response.data.success) {
  //       console.log("✅ Transaction approved successfully:", response.data);
  //       loadWithdrawals();
  //     } else {
  //       console.error("❌ Approval failed:", response.data.message);
  //     }
  //   } catch (error) {
  //     console.error("❌ Error approving transaction:", error);
  //   } finally {
  //     setLoading(false);
  //   }
  // };



  const handleApprove = async (transactionId, newStatus) => {

    setLoading(true);
    try {
      // Find the transaction in the withdrawals array
      const transaction = withdrawals.find(t => t._id === transactionId);

      if (!transaction) {
        console.error("❌ Transaction not found");
        return;
      }

      // Check if the transaction is already in the desired state
      if (transaction.status === newStatus) {
        console.log("ℹ️ Transaction is already in the desired state");
        return;
      }

      // Enforce the conditions
      if (transaction.status === "Success" && newStatus === "Rejected") {
        Swal.fire("Error!", "A successful transaction cannot be rejected.", "error");
        return;
      }

      if (transaction.status === "Rejected" && newStatus === "Success") {
        Swal.fire("Error!", "A rejected transaction cannot be marked as successful.", "error");
        return;
      }

      if (transaction.status === "Success" && newStatus === "Pending") {
        Swal.fire("Error!", "A success transaction cannot be marked as pending.", "error");
        setLoading(false);
        return;
      }
      if (transaction.status === "Rejected" && newStatus === "Success") {
        Swal.fire("Error!", "A rejected transaction cannot be marked as pending.", "error");
        setLoading(false);
        return;
      }
      if (transaction.status === "Rejected" && newStatus === "Pending") {
        Swal.fire("Error!", "A rejected transaction cannot be marked as pending.", "error");
        setLoading(false);
        return;
      }

      // If the new status is "Rejected", open the rejection reason modal
      if (newStatus === "Rejected") {
        setTransactionToReject(transactionId);
        setShowRejectionModal(true);
        return;
      }

      // Proceed with the status change for non-rejected statuses
      const response = await axios.post(
        // "https://api.Cash365days.in/admin/approveTransaction",
         `${process.env.REACT_APP_API_URL}/admin/approveTransaction`,
        {
          transactionId,
          status: newStatus,
        }
      );

      if (response.data.success) {
        console.log("✅ Transaction status updated successfully:", response.data);
        loadWithdrawals();
      } else {
        console.error("❌ Status update failed:", response.data.message);
      }
    } catch (error) {
      console.error("❌ Error updating transaction status:", error);
    } finally {
      setLoading(false);
    }
  };


  const changeStatus = async (transactionId, newStatus) => {
    setLoading(true);
    try {
      const transaction = withdrawals.find(t => t._id === transactionId);
      if (!transaction) {
        console.error("❌ Transaction not found");
        return;
      }

      // Check if the transaction is already in the desired state
      if (transaction.status === newStatus) {
        console.log("ℹ️ Transaction is already in the desired state");
        return;
      }     

      // Proceed with the status change for non-rejected statuses
      const response = await axios.post(
        // "https://api.Cash365days.in/admin/approveUserSettlement",
        `${process.env.REACT_APP_API_URL}/admin/approveUserSettlement`,
        {
          transactionId,
          status: newStatus,
        }
      );

      if (response.data.success) {
        console.log("✅ Settlement status updated successfully:", response.data);
        loadWithdrawals();
      } else {
        console.error("❌Settlement Status update failed:", response.data.message);
      }
    } catch (error) {
      console.error("❌ Error updating transaction status:", error);
    } finally {
      setLoading(false);
    }
  };


  const handleRejectWithReason = async () => {
    const finalReason = rejectionReason === "Custom" ? customReason : rejectionReason;

    if (!finalReason || finalReason.trim() === "") {
      Swal.fire("Error!", "Please provide a rejection reason.", "error");
      return;
    }

    setLoading(true);
    try {
      const response = await axios.post(
        // "https://api.Cash365days.in/admin/approveTransaction",
        `${process.env.REACT_APP_API_URL}/admin/approveTransaction`,
        {
          transactionId: transactionToReject,
          status: "Rejected",
          rejectionReason: finalReason,
        }
      );

      if (response.data.success) {
        console.log("✅ Transaction rejected successfully:", response.data);
        loadWithdrawals(); // refresh the list or UI
      } else {
        console.error("❌ Rejection failed:", response.data.message);
        Swal.fire("Failed", response.data.message || "Rejection failed", "error");
      }
    } catch (error) {
      console.error("❌ Error rejecting transaction:", error);
      Swal.fire("Error!", "An error occurred while rejecting the transaction.", "error");
    } finally {
      setLoading(false);
      setShowRejectionModal(false);
      setRejectionReason("");
      setCustomReason(""); // reset custom input
      setTransactionToReject(null);
    }
  };

  const handleDelete = async (transactionId) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setLoading(true);
        try {
          const response = await axios.delete(
            `${process.env.REACT_APP_API_URL}/user/delete-transaction/${transactionId}`
          );

          if (response.data.success) {
            Swal.fire("Deleted!", "Transaction has been deleted.", "success");
            loadWithdrawals();
          } else {
            Swal.fire("Error!", response.data.message, "error");
          }
        } catch (error) {
          console.error("Error deleting transaction:", error);
          Swal.fire("Error!", "Failed to delete transaction.", "error");
        } finally {
          setLoading(false);
        }
      }
    });
  };

  const handleAction = (action, transactionId) => {
    console.log(`Action: ${action}, Transaction ID: ${transactionId}`);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await axios.post(
        // `https://api.Cash365days.in/admin/updateAmountByAdmin`,
        `${process.env.REACT_APP_API_URL}admin/updateAmountByAdmin`,
        {
          userId: guestId,
          _id: selectedTransactionId,
          amount: parseFloat(selectedAmount),
        }
      );

      if (response.data.success) {
        Swal.fire("Success!", response.data.message, "success");
        setShowModal(false);
        loadWithdrawals();
      } else {
        Swal.fire("Error!", response.data.message, "error");
      }
    } catch (error) {
      console.error("❌ Error updating amount:", error);
      Swal.fire("Error!", "Failed to update amount.", "error");
    } finally {
      setLoading(false);
    }
  };

  // Filter transactions based on the active tab and search query
  const filteredWithdrawals = withdrawals.filter((transaction) => {
    // Filter by tab
    if (activeTab !== "total" && transaction.status.toLowerCase() !== activeTab) {
      return false;
    }
    // Filter by search query
    if (
      searchQuery &&
      !transaction.userName.toLowerCase().includes(searchQuery.toLowerCase())
    ) {
      return false;
    }
    return true;
  });

  // Paginate the filtered transactions
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentWithdrawals = filteredWithdrawals.slice(indexOfFirstItem, indexOfLastItem);

  const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const shareSlip = async (slipImage) => {
    // const slipUrl = `https://api.Cash365days.in/${slipImage}`;
    const slipUrl = `https://api.Cash365days.in/${slipImage}`;

    try {
      // Fetch image as Blob
      const response = await fetch(slipUrl);
      const blob = await response.blob();

      // Convert Blob to File
      const file = new File([blob], "Payment_Slip.jpg", { type: blob.type });

      // Check if Web Share API supports file sharing
      if (navigator.canShare && navigator.canShare({ files: [file] })) {
        await navigator.share({
          files: [file],
          title: "Payment Slip",
          text: "Here is the payment slip.",
        });
      } else {
        alert("Sharing images is not supported on this device.");
      }
    } catch (error) {
      console.error("Error sharing the payment slip:", error);
    }
  };

  const [isDownloading, setIsDownloading] = useState(false);
  const downloadSlip = (imagePath, transactionId) => {
    setIsDownloading(true); // Start loading

    const imageUrl = `https://api.Cash365days.in/${imagePath}`;

    fetch(imageUrl)
      .then((response) => response.blob())
      .then((blob) => {
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = `slip_image_${imagePath}.jpg`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(link.href);
      })
      .catch((error) => {
        console.error("Error downloading image:", error);
      })
      .finally(() => {
        setIsDownloading(false); // Stop loading
      });
  };

  const handleCopyValue = (value, event) => {
    navigator.clipboard
      .writeText(value)
      .then(() => {
        const { clientX, clientY } = event;
        const tooltip = document.getElementById("copy-tooltip");

        tooltip.style.left = `${clientX + 10}px`;
        tooltip.style.top = `${clientY + 10}px`;
        tooltip.style.display = "block";

        setTimeout(() => {
          tooltip.style.display = "none";
        }, 1000);
      })
      .catch((err) => {
        console.error("Failed to copy value:", err);
      });
  };

  return (
    <div className="profile-container">
      <div
        id="copy-tooltip"
        style={{
          position: "fixed",
          display: "none",
          backgroundColor: "rgba(0, 0, 0, 0.75)",
          color: "#fff",
          padding: "4px 8px",
          borderRadius: "4px",
          fontSize: "12px",
          zIndex: 1000,
        }}
      >
        Copied!
      </div>
      <Row className="g-4">
        <Col md={6} lg={3}>
          <Card
            className="shadow-sm text-center overflow-hidden"
            style={{ cursor: "pointer" }}
            onClick={() => setActiveTab("total")}
          >
            <Card.Body className="d-flex align-items-center position-relative p-0">
              <div className="icon-container">
                <i className="bi bi-cash-stack fs-1"></i>
              </div>
              <div className="content_details">
                <Card.Title className="titlefordiv">Total</Card.Title>
                <Card.Text className="cardtext">{totalDeposit}</Card.Text>
              </div>
            </Card.Body>
          </Card>
        </Col>

        <Col md={6} lg={3}>
          <Card
            className="shadow-sm text-center overflow-hidden"
            style={{ cursor: "pointer" }}
            onClick={() => setActiveTab("success")}
          >
            <Card.Body className="d-flex align-items-center position-relative p-0">
              <div className="icon-container">
                <i className="bi bi-cash-stack fs-1"></i>
              </div>
              <div className="content_details">
                <Card.Title className="titlefordiv">Success</Card.Title>
                <Card.Text className="cardtext">{totalSuccessAmount}</Card.Text>
              </div>
            </Card.Body>
          </Card>
        </Col>

        <Col md={6} lg={3}>
          <Card
            className="shadow-sm text-center overflow-hidden"
            style={{ cursor: "pointer" }}
            onClick={() => setActiveTab("pending")}
          >
            <Card.Body className="d-flex align-items-center position-relative p-0">
              <div className="icon-container">
                <i className="bi bi-cash-stack fs-1"></i>
              </div>
              <div className="content_details">
                <Card.Title className="titlefordiv">Pending</Card.Title>
                <Card.Text className="cardtext">{totalPendingAmount}</Card.Text>
              </div>
            </Card.Body>
          </Card>
        </Col>

        <Col md={6} lg={3}>
          <Card
            className="shadow-sm text-center overflow-hidden"
            style={{ cursor: "pointer" }}
            onClick={() => setActiveTab("rejected")}
          >
            <Card.Body className="d-flex align-items-center position-relative p-0">
              <div className="icon-container">
                <i className="bi bi-cash-stack fs-1"></i>
              </div>
              <div className="content_details">
                <Card.Title className="titlefordiv">Rejected</Card.Title>
                <Card.Text className="cardtext">{totalRejectedAmount}</Card.Text>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <div className="table-responsive tablemargin mb-5">
        <div className="d-flex justify-content-between">
          <p className="text-start mt-4 requesthistory">Deposit Transactions</p>

          <div className="d-flex align-items-center">
            <div className="input-group mt-3">
              <span className="input-group-text">
                <i className="bi bi-search"></i>
              </span>
              <input
                type="text"
                placeholder="Search by user name"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className="form-control"
              />
            </div>
          </div>
        </div>
        {loading ? (
          <div className="text-center my-3">
            <Spinner animation="border" role="status" />
            <p>Loading...</p>
          </div>
        ) : (
          <Table striped bordered hover className="tablehistory position-relative">
            <thead>
              <tr className="tablehead text-center">
                <th>#</th>
                {/* <th>Account Holder</th>
                <th>Bank Name</th>
                <th>Account Number</th>
                <th>IFSC Code</th> */}
                <th>QR Code Name</th>
                <th>Transaction Remark</th>
                <th>UTR Number</th>
                <th>Upi Id</th>
                <th>User Name</th>
                <th>Amount</th>
                <th>Deposit</th>
                <th>Date & Time</th>
                <th>Payment Slip</th>
                {/* <th>Download & share</th> */}
                <th>Transaction Status</th>
                {/* <th>Settlement</th> */}
                <th>Actions</th>
              </tr>

            </thead>
            <tbody className="tbodyhistroy text-center">
              {currentWithdrawals.length > 0 ? (
                currentWithdrawals.map((transaction, index) => (
                  <tr className="text-center" key={transaction._id}>
                    <td>{index + indexOfFirstItem + 1}</td>
                    {/* <td onClick={(e) => handleCopyValue(transaction.accountHolderName, e)} className="capitalize-text">{transaction.accountHolderName || "N/A"}</td>
                    <td className="capitalize-text">{transaction.bankName || "N/A"}</td>
                    <td>{transaction.accountNumber || "N/A"}</td>
                    <td>{transaction.ifscCode || "N/A"}</td> */}
                    <td className="capitalize-text">{transaction.qrName || "N/A"}</td>
                    <td className="capitalize-text">{transaction.remark || "N/A"}</td>
                    <td onClick={(e) => handleCopyValue(transaction.utrNumber, e)}>{transaction.utrNumber}</td>
                    <td onClick={(e) => handleCopyValue(transaction.upiId, e)}>{transaction.upiId}</td>
                    <td className="capitalize-text"
                      onClick={(e) => handleCopyValue(transaction.username, e)}
                    >{transaction.username || "N/A"}</td>
                    <td onClick={(e) => handleCopyValue(transaction.amount, e)}>{transaction.amount}</td>
{/* <td>
  {(transaction.status === "Success" || transaction.status === "Pending") ? (
    
    transaction.userSettlement === "no" ? (
      <button
        className="btn btn-warning"
        onClick={() => changeStatus(transaction._id, "yes")}
      >
        Submit
      </button>
    ) : (
      <button className="btn btn-success" disabled>
        Credited
      </button>
    )

  ) : transaction.status === "Rejected" ? (
    
    <span className="text-danger fw-bold">
      Rejected
    </span>

  ) : null}
</td> */}
<td>
  {transaction.status === "Success" ? (
    // <span className="text-success" disabled>
    //   Credited
    // </span>
       transaction.userSettlement === "no" ? (
      <button
        className="btn btn-warning"
        onClick={() => changeStatus(transaction._id, "yes")}
      >
        Submit
      </button>
    ) : (
      <button className="btn btn-success" disabled>
        Credited
      </button>
    )

  ) : transaction.status === "Rejected" ? (
    <span className="text-danger fw-bold">
      Rejected
    </span>

  ) : null}
</td>
<td>
  {new Date(transaction.createdAt).toLocaleString("en-IN", {
    timeZone: "Asia/Kolkata",
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  })}
</td>
                    <td>

                      <img
                        src={`https://api.Cash365days.in/${transaction.slipImage}`}
                        alt="Slip Image"
                        width="70"
                        height="70"
                        style={{ cursor: "pointer" }}
                        onClick={() =>
                          openModal(`https://api.Cash365days.in/${transaction.slipImage}`)
                        }
                      />
                    </td>
                    {/* <td>
                    
                      <Button
                        variant="primary"
                        className="buttonAction mx-1"
                        onClick={() => shareSlip(transaction.slipImage)}
                      >
                        <i className="bi bi-share"></i>
                      </Button>

                      <Button
                        variant="success"
                        className="buttonAction mx-1"
                        onClick={() => downloadSlip(transaction.slipImage, transaction.id)}
                        disabled={isDownloading}
                      >
                        {isDownloading ? (
                          <i className="bi bi-arrow-clockwise spin"></i>
                        ) : (
                          <i className="bi bi-download"></i>
                        )}
                      </Button>
                    </td> */}

                    <td>
                      <select
                        className={`status-select text-white ${transaction.status.toLowerCase()}`}
                        value={transaction.status}
                        onChange={(e) => handleApprove(transaction._id, e.target.value)}
                      >
                        <option value="Pending" className="pending-option">Pending</option>
                        <option value="Success" className="success-option">Success</option>
                        <option value="Rejected" className="rejected-option">Rejected</option>
                      </select>
                    </td>
                  
                    <td>
                      <Button
                        variant="primary"
                        className="buttonAction mx-1"
                        onClick={() => handleOpenModal(transaction)}
                      >
                        <i className="bi bi-pencil-square"></i>
                      </Button>
                    </td>
                  </tr>

                ))
              ) : (
                <tr>
                  <td colSpan="13" className="text-center nodataavl">
                    No Deposit transactions available
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        )}


        <Modal
          show={modalIsOpen}
          onHide={closeModal}
          centered
          dialogClassName="fullscreen-modal modelimage "
        >
          <Modal.Body className="p-0">
            <button className="close-btn" onClick={closeModal}>
              &times;
            </button>
            {selectedImage && (
              <img src={selectedImage} alt="Full slip" className="full-image" />
            )}
          </Modal.Body>
        </Modal>

        <Modal show={showModal} onHide={() => setShowModal(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Update User Balance</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form onSubmit={handleSubmit}>
              <Form.Group className="mb-3">
                <Form.Label>Amount</Form.Label>
                <Form.Control
                  type="number"
                  value={selectedAmount}
                  onChange={(e) => setSelectedAmount(e.target.value)}
                  required
                  min="0.01"
                  step="0.01"
                />
              </Form.Group>
              <Button variant="primary" type="submit" disabled={loading}>
                {loading ? <Spinner animation="border" size="sm" /> : "Submit"}
              </Button>
            </Form>
          </Modal.Body>
        </Modal>
      </div>
      <Row className="">
        <Pagination className="justify-content-center">
          <Pagination.First onClick={() => setCurrentPage(1)} />
          <Pagination.Prev onClick={handlePrevPage} />

          {/* Always show the first two pages */}
          {[...Array(Math.min(2, totalPages))].map((_, index) => (
            <Pagination.Item
              key={index}
              active={index + 1 === currentPage}
              onClick={() => setCurrentPage(index + 1)}
            >
              {index + 1}
            </Pagination.Item>
          ))}

          {/* Show ellipsis if current page is beyond the first two pages */}
          {currentPage > 3 && <Pagination.Ellipsis disabled />}

          {/* Show current page and its neighbors */}
          {currentPage > 2 && currentPage < totalPages - 1 && (
            <>
              <Pagination.Item
                active
                onClick={() => setCurrentPage(currentPage)}
              >
                {currentPage}
              </Pagination.Item>
            </>
          )}

          {/* Show ellipsis if current page is not near the end */}
          {currentPage < totalPages - 2 && <Pagination.Ellipsis disabled />}

          {/* Always show the last two pages */}
          {[...Array(Math.min(2, totalPages))].map((_, index) => {
            const pageNumber = totalPages - 1 - index;
            return (
              pageNumber > 1 && (
                <Pagination.Item
                  key={pageNumber}
                  active={pageNumber === currentPage}
                  onClick={() => setCurrentPage(pageNumber)}
                >
                  {pageNumber}
                </Pagination.Item>
              )
            );
          }).reverse()}

          <Pagination.Next onClick={handleNextPage} />
          <Pagination.Last onClick={() => setCurrentPage(totalPages)} />
        </Pagination>
      </Row>
      <Modal show={showRejectionModal} onHide={() => setShowRejectionModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Provide Rejection Reason</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Select Remark</Form.Label>
              <Form.Select
                value={rejectionReason}
                onChange={(e) => setRejectionReason(e.target.value)}
                required
              >
                {rejectionOptions.map((reason, index) => (
                  <option key={index} value={reason === "-- Select Remark --" ? "" : reason}>
                    {reason}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>

            {rejectionReason === "Custom" && (
              <Form.Group className="mb-3">
                <Form.Label>Custom Reason</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  value={customReason}
                  onChange={(e) => setCustomReason(e.target.value)}
                  placeholder="Enter custom reason"
                  required
                />
              </Form.Group>
            )}
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowRejectionModal(false)}>
            Cancel
          </Button>
          {/* <Button
            variant="primary"
            onClick={() => handleRejectWithReason(rejectionReason === "Custom" ? customReason : rejectionReason)}
            disabled={loading}
          >
            {loading ? <Spinner animation="border" size="sm" /> : "Submit"}
          </Button> */}
          <Button
            variant="primary"
            onClick={handleRejectWithReason}
            disabled={
              loading ||
              rejectionReason === "" ||
              (rejectionReason === "Custom" && customReason.trim() === "")
            }
          >
            {loading ? <Spinner animation="border" size="sm" /> : "Submit"}
          </Button>

        </Modal.Footer>
      </Modal>
      <footer className="text-center p-3 bg-light mt-3">
        <p className="mb-0">
          &copy; Case 365 Days. All Rights Reserved.
        </p>
        {/* <p className="mb-0">
          &copy; {new Date().getFullYear()} Your Company Name. All Rights Reserved.
        </p> */}
      </footer>
    </div>
  );
};

export default Withdraw;


